class Meganav {
  constructor() {
    this.mainNav = document.querySelector('nav.main-navigation');
    this.mobileNav = document.querySelector('.mobile-main-navigation');

    if (this.mainNav) {
      [this.mainNav, this.mobileNav].forEach((container) => {
        container.querySelectorAll('.main-nav-control .nav-link').forEach((elem) => {
          elem.addEventListener('click', this.onControlClick.bind(this));
        })
      });

      [this.mainNav].forEach((container) => {
        container.querySelectorAll('.main-nav-control .nav-link').forEach((elem) => {
          elem.addEventListener('mouseover', this.openMenu.bind(this));
        })
      });

      this.mainNav.addEventListener('mouseover', function (event) { event.stopPropagation(); });
      this.mainNav.addEventListener('mouseleave', this.closeMenu.bind(this));

      document.addEventListener('click', this.onClickOutside.bind(this));
      this.mainNav.addEventListener('transitionend', this.onMainNavFade.bind(this));
      this.mobileNav.querySelector('.mobile-menu-panel-secondary').addEventListener('transitionend', this.onMobileSubFade.bind(this));
      this.mobileNav.querySelectorAll('.mobile-submenu-back').forEach((elem) => {
        elem.addEventListener('click', this.onMobileBackClick.bind(this));
      })
      document.querySelector('#mobile-navigation .btn-close').addEventListener('click', () => {
        this.closeMenu();
      })
    }
  }

  onControlClick(evt) {
    if (!evt.currentTarget.getAttribute('data-wf-target') || (this.mainNav.classList.contains('open') && this.mainNav.querySelector(evt.currentTarget.getAttribute('data-wf-target')).classList.contains('open'))) {
      this.closeMenu();
    } else {
      this.openMenu(evt);
    }
  }

  openMenu(evt) {
    this.mobileNav.querySelector('.mobile-menu-panel-secondary').classList.remove('d-none');
    let target = evt.currentTarget;
    window.requestAnimationFrame(() => {
      [this.mainNav, this.mobileNav].forEach((container) => {
        container.querySelectorAll('.main-nav-control .nav-link').forEach((elem) => {
          elem.setAttribute('aria-expanded', elem == target ? 'true' : 'false');
          elem.classList.toggle('is-open', elem == target);
        })
        container.querySelectorAll('.main-nav-panel').forEach((elem) => {
          if (elem.matches(target.getAttribute('data-wf-target'))) {
            elem.classList.add('open');
            setTimeout(() => {
              elem.setAttribute('aria-hidden', 'false');
            }, 200); //match transition timing
          } else {
            elem.classList.remove('open');
            elem.setAttribute('aria-hidden', 'true');
          }
        })
        container.classList.add('open');
      });
    });

  }

  closeMenu() {
    [this.mainNav, this.mobileNav].forEach((container) => {
      container.classList.remove('open');
      container.querySelectorAll('[aria-expanded=true]').forEach((elem) => {
        elem.setAttribute('aria-expanded', 'false');
        elem.classList.remove('is-open');
      })
    })
  }

  onMainNavFade(evt) {
    if (!evt.currentTarget.classList.contains('open')) {
      this.mainNav.querySelectorAll('.main-nav-panel').forEach((elem) => {
        elem.classList.remove('open');
        elem.setAttribute('aria-hidden', 'true');
      })
    }
  }

  onMobileSubFade(evt) {
    if (!evt.currentTarget.closest('.mobile-main-navigation').classList.contains('open')) {
      this.mobileNav.querySelectorAll('.mobile-submenu-panel').forEach((elem) => {
        elem.classList.remove('open');
        elem.setAttribute('aria-hidden', 'true');
      })
      evt.currentTarget.classList.add('d-none');
    }
  }

  onClickOutside(evt) {
    if (evt.target.closest('.main-navigation') == null && evt.target.closest('#mobile-navigation') == null || evt.target.matches('.navbar-nav a.nav-link')) {
      this.closeMenu();
    }
  }

  onMobileBackClick(evt) {
    this.closeMenu();
  }
}

document.addEventListener('DOMContentLoaded', () => {
  var meganav = new Meganav();
})
